import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Heading6 } from '@ui/Typography'

import { useWindowResize } from '@utils/domUtils'

import styles from '../LuckyDraw.modal.module.scss'

interface WonMessageProps {
  sectors: any[]
  winner: number
  onClose: () => void
}

export const WonMessage: React.FC<WonMessageProps> = ({ sectors, winner }) => {
  const { t } = useTranslation()
  const sector = sectors[winner]

  const rewardTypeId = sector?.rewardType?.id as number | undefined

  const amount = sector?.reward ?? 0
  const currency = sector?.currency?.id || 'USD'

  const isMobile = useWindowResize()

  const renderMessage = () => {
    switch (rewardTypeId) {
      case 1:
        return (
          <>
            <Heading6 isParagraph medium>
              {t('luckyDraw.congratulations')}
            </Heading6>
            <Body1>
              {t('luckyDraw.youHaveWon')}{' '}
              <span className={styles.highlight}>
                {amount} {currency}
              </span>
              <span>!</span>
            </Body1>
            <Body1>{t('luckyDraw.willDeposit', { currency })}</Body1>
          </>
        )
      case 2:
        return (
          <>
            <Heading6 isParagraph medium>
              {t('luckyDraw.congratulations')}
            </Heading6>
            <Body1>
              {t('luckyDraw.spinsPrefix')}{' '}
              <span className={styles.highlight}>
                {amount}{' '}
                {amount === 1 ? t('luckyDraw.spinsWordSingular') : t('luckyDraw.spinsWord')}
              </span>
            </Body1>
            <Body1>{t('luckyDraw.spinsTail')}</Body1>
          </>
        )
      case 3:
        return (
          <>
            <Heading6 isParagraph medium>
              {t('luckyDraw.noPrizeTitle')}
            </Heading6>
            <Body1 isParagraph medium>
              {t('luckyDraw.noPrizeMid')}{' '}
              {!isMobile && <span className={styles.highlight}>{t('luckyDraw.noPrizeTail')}</span>}
            </Body1>
            {isMobile && (
              <Body1 isParagraph medium className={styles.highlight}>
                {t('luckyDraw.noPrizeTail')}
              </Body1>
            )}
          </>
        )
      default:
        if (amount > 0) {
          const typeLabel = sector?.rewardType?.name ?? (currency || '')
          return (
            <>
              <Heading6 isParagraph medium>
                {t('luckyDraw.congratulations')}
              </Heading6>
              <Body1>
                {t('luckyDraw.youHaveWon')}{' '}
                <span className={styles.highlight}>
                  {amount} {typeLabel}
                </span>
                <span>!</span>
              </Body1>
            </>
          )
        }
        return (
          <>
            <Heading6 isParagraph medium>
              {t('luckyDraw.noPrizeTitle')}
            </Heading6>
            <Body1 isParagraph medium>
              {t('luckyDraw.noPrizeMid')}{' '}
              <span className={styles.highlight}>{t('luckyDraw.noPrizeTail')}</span>
            </Body1>
          </>
        )
    }
  }

  const isNoPrize = rewardTypeId === 3

  return (
    <div className={classNames(styles.winningsBox, { [styles.noConfetti]: isNoPrize })}>
      {renderMessage()}
    </div>
  )
}
